import type { PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    chat: {
      assistantBg: string;
      assistantText: string;
    };
    surface: {
      codeBlock: string;
      blockquote: string;
      tableHeader: string;
    };
  }
  interface PaletteOptions {
    chat?: {
      assistantBg?: string;
      assistantText?: string;
    };
    surface?: {
      codeBlock?: string;
      blockquote?: string;
      tableHeader?: string;
    };
  }
}

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#6366f1',
  },
  secondary: {
    main: '#8b5cf6',
  },
  background: {
    default: '#0f172a',
    paper: '#1e293b',
  },
  chat: {
    assistantBg: '#1e293b',
    assistantText: '#e2e8f0',
  },
  surface: {
    codeBlock: 'rgba(255, 255, 255, 0.05)',
    blockquote: 'rgba(255, 255, 255, 0.02)',
    tableHeader: 'rgba(255, 255, 255, 0.05)',
  },
};

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#4f46e5',
    light: '#818cf8',
    dark: '#3730a3',
  },
  secondary: {
    main: '#7c3aed',
    light: '#a78bfa',
    dark: '#5b21b6',
  },
  background: {
    default: '#f1f5f9',
    paper: '#ffffff',
  },
  text: {
    primary: '#1e293b',
    secondary: '#475569',
  },
  divider: '#e2e8f0',
  chat: {
    assistantBg: '#ffffff',
    assistantText: '#1e293b',
  },
  surface: {
    codeBlock: '#f1f5f9',
    blockquote: '#f8fafc',
    tableHeader: '#f1f5f9',
  },
};

export const cloud2DarkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#ff578c',
    light: '#ff7aa6',
    dark: '#c94585',
  },
  secondary: {
    main: '#ff7aa6',
    light: '#ff9dbd',
    dark: '#ff578c',
  },
  background: {
    default: '#08080d',
    paper: '#0d0d14',
  },
  text: {
    primary: '#e8e8f2',
    secondary: '#8a8aa4',
  },
  divider: '#30304a',
  chat: {
    assistantBg: '#13131f',
    assistantText: '#e8e8f2',
  },
  surface: {
    codeBlock: '#1a1a2a',
    blockquote: '#13131f',
    tableHeader: '#1a1a2a',
  },
};

export const mrRobotPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#00ff41',
    light: '#66ff8c',
    dark: '#00cc33',
  },
  secondary: {
    main: '#00cc33',
    light: '#00ff41',
    dark: '#009926',
  },
  info: {
    main: '#009926',
    light: '#00cc33',
    dark: '#006619',
  },
  success: {
    main: '#00ff41',
    light: '#66ff8c',
    dark: '#00cc33',
  },
  error: {
    main: '#ff0040',
    light: '#ff4d73',
    dark: '#cc0033',
  },
  warning: {
    main: '#ffd700',
    light: '#ffe44d',
    dark: '#ccac00',
  },
  background: {
    default: '#0a0a0a',
    paper: '#111111',
  },
  text: {
    primary: '#c0c0c0',
    secondary: '#888888',
  },
  divider: '#1e1e1e',
  action: {
    active: '#00ff41',
    hover: 'rgba(0, 255, 65, 0.08)',
    selected: 'rgba(0, 255, 65, 0.16)',
    disabled: '#555555',
    disabledBackground: '#1a1a1a',
  },
  chat: {
    assistantBg: '#0d0d0d',
    assistantText: '#c0c0c0',
  },
  surface: {
    codeBlock: '#0d0d0d',
    blockquote: '#0a0a0a',
    tableHeader: '#1a1a1a',
  },
};

export const cloud2LightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#e8456f',
    light: '#ff578c',
    dark: '#c94585',
  },
  secondary: {
    main: '#c94585',
    light: '#e8456f',
    dark: '#a03870',
  },
  background: {
    default: '#f5f5fa',
    paper: '#ffffff',
  },
  text: {
    primary: '#1a1a2e',
    secondary: '#52526a',
  },
  divider: '#d0d0de',
  chat: {
    assistantBg: '#ffffff',
    assistantText: '#1a1a2e',
  },
  surface: {
    codeBlock: '#f0f0f6',
    blockquote: '#f5f5fa',
    tableHeader: '#e5e5ef',
  },
};
